module.exports = __webpack_public_path__ + "img/dq_pic_speedlog.7b82d192.png";